import { useState, useCallback } from 'react';

interface HubSpotFormConfig {
	region?: string;
	portalId: string;
	formId: string;
	target: string;
}

interface UseHubSpotContactFormReturn {
	isOpen: boolean;
	isSubmitted: boolean;
	openModal: () => void;
	closeModal: () => void;
	initializeForm: (config: Omit<HubSpotFormConfig, 'onFormSubmit'>) => void;
}


export const useHubSpotContactForm = (): UseHubSpotContactFormReturn => {
	const [isOpen, setIsOpen] = useState(false);
	const [isSubmitted, setIsSubmitted] = useState(false);

	const openModal = useCallback(() => {
		setIsOpen(true);
		setIsSubmitted(false); 
	}, []);

	const closeModal = useCallback(() => {
		setIsOpen(false);
	}, []);

	const initializeForm = useCallback((config: Omit<HubSpotFormConfig, 'onFormSubmit'>) => {
		if (window.hbspt?.forms) {
			window.hbspt.forms.create({
				region: config.region || 'na1',
				portalId: config.portalId,
				formId: config.formId,
				target: config.target,
				onFormSubmit: () => {
					setIsSubmitted(true);
				}
			});
		}
	}, []);

	return {
		isOpen,
		isSubmitted,
		openModal,
		closeModal,
		initializeForm
	};
};

